// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    // Box,
//    // Stepper,
//    // Step,
//    // StepIndicator,
//    // StepStatus,
//    // StepIcon,
//    // StepNumber,
//    // StepTitle,
//    // StepDescription,
//    // StepSeparator,
//    useToast,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getBank, addBank, updateBank } from '../../../../../redux/actions/bank';
// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import '../../../companyProfile/css.css';
// import { getArea } from '../../../../../redux/actions/area';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal } from 'contexts';
// import { useUser } from 'contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
//    ifsc: Yup.string().required('IFSC is required').length(11, 'IFSC must be exactly 11 characters long'),
//    arId: Yup.number()
//       .required('AR ID is required')
//       .positive('AR ID must be a positive number')
//       .integer('AR ID must be an integer'),
//    address: Yup.string().required('Address is required').min(10, 'Address must be at least 10 characters long'),
//    pincode: Yup.number()
//       .required('Pincode is required')
//       .positive('Pincode must be a positive number')
//       .integer('Pincode must be an integer')
//       .min(100000, 'Pincode must be a valid 6-digit number'),
//    landline: Yup.number()
//       .required('Landline is required')
//       .positive('Landline must be a positive number')
//       .integer('Landline must be an integer')
//       .min(1000000000, 'Landline must be at least 11 digits long'),
//    mobile: Yup.number()
//       .required('Mobile number is required')
//       .positive('Mobile number must be a positive number')
//       .integer('Mobile number must be an integer')
//       .min(100000000, 'Mobile number must be at least 10 digits long'),
//    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
//    contactPerson: Yup.string()
//       .required('Contact Person is required')
//       .min(3, 'Contact Person must be at least 3 characters long'),
// });

// // const steps = [
// //   { title: 'First', description: 'Enter Bank-Account Information' },
// //   { title: 'Second', description: 'Review and Save' },
// // ];

// const BankAccountsForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    saveandcontinue = true,
// }) => {
//    const [row, setRow] = useState({
//       name: '',
//       ifsc: '',
//       address: '',
//       arId: '',
//       pincode: '',
//       landline: '',
//       mobile: '',
//       email: '',
//       contactPerson: '',
//       compIds: [],
//    });
//    const { user } = useUser();
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    // const [activeStep, setActiveStep] = useState(0);
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const dbName = localStorage.getItem('dbName');
//    const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.bankBranch;
//    const shouldShowCompanyDropdown = globalSetting || false;
//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );
//    const itemGroupData = useSelector((state) => state.itemGroup.list);
//    const areaData = useSelector((state) => state.area.list);

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          ifsc: '',
//          arId: '',
//          address: '',
//          pincode: '',
//          landline: '',
//          mobile: '',
//          email: '',
//          contactPerson: '',
//       });
//       setErrors({});
//    };

//    useEffect(() => {
//       if (user?.loginhistory?.companyId && !isEditMode) {
//          // Only set if not in edit mode and compIds is empty or doesn't include the user's company
//          setRow((prev) => {
//             if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
//                return {
//                   ...prev,
//                   compIds: [user.loginhistory.companyId],
//                };
//             }
//             return prev;
//          });
//       }
//    }, [user?.loginhistory?.companyId, isEditMode]);

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//          setRow((prev) => ({
//             ...prev,
//             compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
//          }));
//       } else if (isOpen && isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             ifsc: currentRow.ifsc || '',
//             arId: currentRow.arId || '',
//             address: currentRow.address || '',
//             pincode: currentRow.pincode || '',
//             mobile: currentRow.mobile || '',
//             landline: currentRow.landline || '',
//             email: currentRow.email || '',
//             contactPerson: currentRow.contactPerson || '',
//             compIds: currentRow.compIds,
//          });
//       }
//    }, [isEditMode, currentRow, isOpen]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     if (activeStep < steps.length - 1) {
//    //       setActiveStep(activeStep + 1);
//    //     }
//    //   } else {
//    //     toast({
//    //       title: 'Validation Error',
//    //       description: 'Please correct the errors before proceeding.',
//    //       status: 'error',
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    // const handlePrevious = () => {
//    //   if (activeStep > 0) {
//    //     setActiveStep(activeStep - 1);
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          arId: Number(row.arId),
//          compIds: row.compIds,
//          pincode: row.pincode?.toString(),
//          landline: row.landline?.toString(),
//          mobile: row.mobile?.toString(),
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateBank(processedData));
//          } else {
//             // Add new item
//             await dispatch(addBank(processedData));
//          }
//          dispatch(getBank());
//          // Close the modal
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Bank.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          arId: Number(row.arId),
//          pincode: row.pincode?.toString(),
//          landline: row.landline?.toString(),
//          mobile: row.mobile?.toString(),
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateBank(processedData));
//          } else {
//             // Add new item
//             await dispatch(addBank(processedData));
//          }
//          dispatch(getBank());
//          clearFormData();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the Bank.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(getArea());
//       }
//    }, [dispatch, isOpen]);

//    const handleCansel = async () => {
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//    };
//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             // e.preventDefault(); // prevent browser default (e.g. save page)

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSubmit(); // S only
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             onClose();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//       demoname = '';
//    }, [demoname, row.name]);

//    const nameInputRef = useRef();
//    const savefinishRef = useRef(null);
//    const mobileRef = useRef();
//    const emailRef = useRef();
//    const contactPersonRef = useRef();
//    const addressRef = useRef();
//    const pincodeRef = useRef();
//    const landlineRef = useRef();
//    const areaRef = useRef();
//    const ifscRef = useRef();
//    // const nameInputRef = useRef();

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             handleCansel();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [handleCansel]);

//    return (
//       <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '5%', md: '20%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Bank-Branch' : 'Add New Bank-Branch'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={2}>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  ifscRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'ifsc',
//                         'IFSC',
//                         {
//                            value: row.ifsc,
//                            onChange: (e) => handleInputChange('ifsc', e.target.value),
//                            ref: ifscRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  areaRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {/* {renderFormControl(
//                 'arId',
//                 'arId',
//                 {
//                   value: row.arId,
//                   onChange: (e) => handleInputChange('arId', e.target.value),
//                 },
//                 errors,
//                 textColor,
//                 'number',
//                 true, // optional: mark as required
//               )} */}

//                      {renderDynamicDropdown(
//                         'arId',
//                         'Area',
//                         areaData,
//                         {
//                            value: row.arId,
//                            onChange: (value) => handleInputChange('arId', value),
//                            ref: areaRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  addressRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Area',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'address',
//                         'Address',
//                         {
//                            value: row.address,
//                            onChange: (e) => handleInputChange('address', e.target.value),
//                            ref: addressRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  pincodeRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'pincode',
//                         'pincode',
//                         {
//                            value: row.pincode,
//                            onChange: (e) => handleInputChange('pincode', e.target.value),
//                            ref: pincodeRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  landlineRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'landline',
//                         'landline',
//                         {
//                            value: row.landline,
//                            onChange: (e) => handleInputChange('landline', e.target.value),
//                            ref: landlineRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  mobileRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'mobile',
//                         'mobile',
//                         {
//                            value: row.mobile,
//                            onChange: (e) => handleInputChange('mobile', e.target.value),
//                            ref: mobileRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  emailRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'email',
//                         'email',
//                         {
//                            value: row.email,
//                            onChange: (e) => handleInputChange('email', e.target.value),
//                            ref: emailRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  contactPersonRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'email',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   {shouldShowCompanyDropdown && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'contactPerson',
//                         'Contact Person',
//                         {
//                            value: row.contactPerson,
//                            onChange: (e) => handleInputChange('contactPerson', e.target.value),
//                            ref: contactPersonRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  savefinishRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                </Grid>
//                {/* )} */}

//                {/* {activeStep === 1 && (
//             <Box mt={8}>
//               <strong>Name:</strong> {row.name}
//               <br />
//               <strong>Ordinal:</strong> {row.ordinal}
//               <br />
//             </Box>
//           )} */}
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//             <Button
//               onClick={handlePrevious}
//               variant="ghost"
//               colorScheme="teal"
//               mr={3}
//             >
//               Previous
//             </Button>
//           )}

//           {activeStep < steps.length - 1 && (
//             <Button onClick={handleNext} colorScheme="teal">
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={savefinishRef}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                <Button variant="ghost" onClick={handleCansel} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default BankAccountsForm;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getBank, addBank, updateBank } from '../../../../../redux/actions/bank';
import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
import '../../../companyProfile/css.css';
import { getArea } from '../../../../../redux/actions/area';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal } from 'contexts';
import { useUser } from 'contexts';
import { BsBank } from 'react-icons/bs';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   ifsc: Yup.string().required('IFSC is required').length(11, 'IFSC must be exactly 11 characters long'),
   arId: Yup.number()
      .required('AR ID is required')
      .positive('AR ID must be a positive number')
      .integer('AR ID must be an integer'),
   address: Yup.string().required('Address is required').min(10, 'Address must be at least 10 characters long'),
   pincode: Yup.number()
      .required('Pincode is required')
      .positive('Pincode must be a positive number')
      .integer('Pincode must be an integer')
      .min(100000, 'Pincode must be a valid 6-digit number'),
   landline: Yup.number()
      .required('Landline is required')
      .positive('Landline must be a positive number')
      .integer('Landline must be an integer')
      .min(1000000000, 'Landline must be at least 11 digits long'),
   mobile: Yup.number()
      .required('Mobile number is required')
      .positive('Mobile number must be a positive number')
      .integer('Mobile number must be an integer')
      .min(100000000, 'Mobile number must be at least 10 digits long'),
   email: Yup.string().required('Email is required').email('Email must be a valid email address'),
   contactPerson: Yup.string()
      .required('Contact Person is required')
      .min(3, 'Contact Person must be at least 3 characters long'),
});

const BankAccountsForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   saveandcontinue = true,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [row, setRow] = useState({
      name: '',
      ifsc: '',
      address: '',
      arId: '',
      pincode: '',
      landline: '',
      mobile: '',
      email: '',
      contactPerson: '',
      compIds: [],
   });
   const { user } = useUser();
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();
   const { companyList, userGlobalSettingsData } = useGlobal();
   const dbName = localStorage.getItem('dbName');
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.bankBranch;
   const shouldShowCompanyDropdown = globalSetting || false;

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const itemGroupData = useSelector((state) => state.itemGroup.list);
   const areaData = useSelector((state) => state.area.list);

   const clearFormData = () => {
      setRow({
         name: '',
         ifsc: '',
         arId: '',
         address: '',
         pincode: '',
         landline: '',
         mobile: '',
         email: '',
         contactPerson: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isOpen && isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            ifsc: currentRow.ifsc || '',
            arId: currentRow.arId || '',
            address: currentRow.address || '',
            pincode: currentRow.pincode || '',
            mobile: currentRow.mobile || '',
            landline: currentRow.landline || '',
            email: currentRow.email || '',
            contactPerson: currentRow.contactPerson || '',
            compIds: currentRow.compIds,
         });
      }
   }, [isEditMode, currentRow, isOpen]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         arId: Number(row.arId),
         compIds: row.compIds,
         pincode: row.pincode?.toString(),
         landline: row.landline?.toString(),
         mobile: row.mobile?.toString(),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateBank(processedData));
         } else {
            await dispatch(addBank(processedData));
         }
         dispatch(getBank());
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Bank.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         arId: Number(row.arId),
         pincode: row.pincode?.toString(),
         landline: row.landline?.toString(),
         mobile: row.mobile?.toString(),
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateBank(processedData));
         } else {
            await dispatch(addBank(processedData));
         }
         dispatch(getBank());
         clearFormData();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Bank.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      if (isOpen) {
         dispatch(getArea());
      }
   }, [dispatch, isOpen]);

   const handleCansel = async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   const nameInputRef = useRef();
   const savefinishRef = useRef(null);
   const cancelRef = useRef(null);
   const savecontinueRef = useRef(null);
   const mobileRef = useRef();
   const emailRef = useRef();
   const contactPersonRef = useRef();
   const addressRef = useRef();
   const pincodeRef = useRef();
   const landlineRef = useRef();
   const areaRef = useRef();
   const ifscRef = useRef();

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel]);

   return (
      <Modal
         isOpen={isOpen}
         onClose={handleCansel}
         size="4xl"
         isCentered // This centers the modal vertically
         motionPreset="slideInBottom" // Optional: adds nice animation
      >
         <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.300" />
         <ModalContent
            className={`
      ${
         isDark
            ? 'bg-gradient-to-br from-gray-800 via-gray-900 to-slate-900'
            : 'bg-gradient-to-br from-white via-gray-50 to-slate-50'
      }
      ${isDark ? 'shadow-2xl shadow-blue-900/20' : 'shadow-2xl shadow-gray-300/50'}
    `}
            borderRadius="24px"
            border={isDark ? '1px solid rgba(59, 130, 246, 0.2)' : '1px solid rgba(229, 231, 235, 0.8)'}
            p={0}
            mx="15px"
            // Remove mt prop since isCentered will handle positioning
            overflow="hidden">
            {/* Enhanced Header with Gradient */}
            <div className="relative overflow-hidden">
               {/* Animated Background Layer */}
               <div
                  className={`absolute inset-0 ${
                     isDark
                        ? 'bg-gradient-to-br from-slate-900 via-blue-950 to-purple-950'
                        : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50'
                  }`}>
                  <div
                     className={`absolute inset-0 ${
                        isDark
                           ? 'bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-600/10 via-transparent to-purple-600/10'
                           : 'bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-200/30 via-transparent to-purple-200/30'
                     }`}></div>
               </div>

               {/* Glass Morphism Overlay */}
               <div
                  className={`absolute inset-0 ${
                     isDark ? 'bg-white/[0.02] backdrop-blur-md' : 'bg-white/40 backdrop-blur-md'
                  }`}></div>

               <ModalHeader className="relative" fontSize="24px" fontWeight="800" py={6} px={''}>
                  {/* Content Container with Enhanced Styling */}
                  <div className="relative">
                     <div className="flex items-center gap-4 ml-8">
                        {/* Icon Container with Glow Effect */}
                        <div className="relative group">
                           <div
                              className={`absolute inset-0 rounded-2xl blur-xl transition-all duration-300 ${
                                 isDark
                                    ? 'bg-gradient-to-r from-blue-500/30 to-purple-500/30 group-hover:from-blue-500/50 group-hover:to-purple-500/50'
                                    : 'bg-gradient-to-r from-blue-400/40 to-purple-400/40 group-hover:from-blue-400/60 group-hover:to-purple-400/60'
                              }`}></div>
                           <div
                              className={`relative p-3 rounded-2xl border-2 transition-all duration-300 ${
                                 isDark
                                    ? 'bg-gradient-to-br from-blue-600/20 to-purple-600/20 border-blue-500/40 group-hover:border-blue-400/60 shadow-lg shadow-blue-500/20'
                                    : 'bg-gradient-to-br from-blue-100 to-purple-100 border-blue-300/60 group-hover:border-blue-400/80 shadow-lg shadow-blue-300/30'
                              }`}>
                              <BsBank className={`text-xl ${isDark ? 'text-blue-300' : 'text-blue-600'}`} />
                           </div>
                        </div>

                        {/* Title with Enhanced Gradient */}
                        <div className="flex flex-col gap-1">
                           <span
                              className={`text-2xl font-bold bg-gradient-to-r ${
                                 isDark
                                    ? 'from-blue-200 via-purple-200 to-indigo-200'
                                    : 'from-blue-700 via-purple-700 to-indigo-700'
                              } bg-clip-text text-transparent drop-shadow-sm`}>
                              {isEditMode ? 'Edit Bank Branch' : 'Add New Bank Branch'}
                           </span>
                           {/* Subtitle */}
                           <span className={`text-xs font-medium ${isDark ? 'text-blue-300/70' : 'text-blue-600/70'}`}>
                              {isEditMode ? 'Update branch information' : 'Create a new branch entry'}
                           </span>
                        </div>
                     </div>

                     {/* Border Line with Multiple Gradients */}
                     <div
                        className={`absolute -bottom-6 left-0 right-0 h-[1px] ${
                           isDark
                              ? 'bg-gradient-to-r from-transparent via-blue-500/50 to-transparent'
                              : 'bg-gradient-to-r from-transparent via-blue-300/50 to-transparent'
                        }`}></div>

                     {/* Bottom Accent Bar with Shadow */}
                     <div className="absolute -bottom-6 left-0 right-0 h-1 overflow-hidden">
                        <div
                           className={`h-full bg-gradient-to-r ${
                              isDark
                                 ? 'from-blue-500 via-purple-500 to-cyan-500 shadow-[0_0_15px_rgba(59,130,246,0.5)]'
                                 : 'from-blue-400 via-purple-400 to-cyan-400 shadow-[0_0_15px_rgba(59,130,246,0.3)]'
                           } animate-pulse`}></div>
                     </div>
                  </div>
               </ModalHeader>

               {/* Enhanced Close Button */}
               <ModalCloseButton
                  className={`absolute top-5 right-6 group transition-all duration-300 rounded-xl w-9 h-9 border-2 ${
                     isDark
                        ? 'text-gray-300 hover:text-white bg-slate-800/50 hover:bg-red-600/20 border-slate-700 hover:border-red-500/60 shadow-lg shadow-slate-900/50'
                        : 'text-gray-600 hover:text-gray-900 bg-white/60 hover:bg-red-50 border-gray-300 hover:border-red-400/60 shadow-lg shadow-gray-300/30'
                  } backdrop-blur-sm`}
                  _focus={{ boxShadow: 'none' }}
                  _hover={{
                     transform: 'scale(1.05) rotate(90deg)',
                  }}
               />
            </div>

            <ModalBody
               className={`
      ${isDark ? 'bg-gray-900/50' : 'bg-white/80'}
      px-8 py-6
    `}>
               {/* Bank Information Section */}
               <div
                  className={`
        mb-6 pb-4 border-b-2 
        ${
           isDark
              ? 'border-blue-500/30 bg-gradient-to-r from-blue-900/20 to-indigo-900/20'
              : 'border-blue-200 bg-gradient-to-r from-blue-50 to-indigo-50'
        }
        rounded-xl p-4 shadow-md
      `}>
                  <h3
                     className={`
          text-lg font-bold mb-4 flex items-center gap-2
          ${isDark ? 'text-blue-300' : 'text-blue-700'}
        `}>
                     <span className="text-2xl">🏦</span>
                     Bank Information
                  </h3>
                  <Grid
                     templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                     gap={4}>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'name',
                           'Name',
                           {
                              value: row.name,
                              onChange: (e) => handleInputChange('name', e.target.value),
                              ref: nameInputRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    ifscRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'ifsc',
                           'IFSC',
                           {
                              value: row.ifsc,
                              onChange: (e) => handleInputChange('ifsc', e.target.value),
                              ref: ifscRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    areaRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'arId',
                           'Area',
                           areaData,
                           {
                              value: row.arId,
                              onChange: (value) => handleInputChange('arId', value),
                              ref: areaRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    addressRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           false,
                           'Select Area',
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'address',
                           'Address',
                           {
                              value: row.address,
                              onChange: (e) => handleInputChange('address', e.target.value),
                              ref: addressRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    pincodeRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'pincode',
                           'Pincode',
                           {
                              value: row.pincode,
                              onChange: (e) => handleInputChange('pincode', e.target.value),
                              ref: pincodeRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    landlineRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'number',
                           true,
                        )}
                     </GridItem>
                  </Grid>
               </div>

               {/* Contact Information Section */}
               <div
                  className={`
        mb-4 pb-4 border-b-2 
        ${
           isDark
              ? 'border-purple-500/30 bg-gradient-to-r from-purple-900/20 to-pink-900/20'
              : 'border-purple-200 bg-gradient-to-r from-purple-50 to-pink-50'
        }
        rounded-xl p-4 shadow-md
      `}>
                  <h3
                     className={`
          text-lg font-bold mb-4 flex items-center gap-2
          ${isDark ? 'text-purple-300' : 'text-purple-700'}
        `}>
                     <span className="text-2xl">📞</span>
                     Contact Information
                  </h3>
                  <Grid
                     templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                     gap={4}>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'landline',
                           'Landline',
                           {
                              value: row.landline,
                              onChange: (e) => handleInputChange('landline', e.target.value),
                              ref: landlineRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    mobileRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'number',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'mobile',
                           'Mobile',
                           {
                              value: row.mobile,
                              onChange: (e) => handleInputChange('mobile', e.target.value),
                              ref: mobileRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    emailRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'number',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'email',
                           'Email',
                           {
                              value: row.email,
                              onChange: (e) => handleInputChange('email', e.target.value),
                              ref: emailRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    contactPersonRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'email',
                           true,
                        )}
                     </GridItem>
                     <GridItem className="seperator-width">
                        {DynamicInput(
                           'contactPerson',
                           'Contact Person',
                           {
                              value: row.contactPerson,
                              onChange: (e) => handleInputChange('contactPerson', e.target.value),
                              ref: contactPersonRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    savefinishRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           textColor,
                           'text',
                           true,
                        )}
                     </GridItem>
                     {shouldShowCompanyDropdown && (
                        <GridItem className="seperator-width" colSpan={{ base: 1, md: 2 }}>
                           {renderDynamicUiDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: row.compIds,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     )}
                  </Grid>
               </div>
            </ModalBody>

            <ModalFooter
               className={`relative ${
                  isDark
                     ? 'bg-gradient-to-r from-gray-900/80 to-gray-800/80 border-t border-gray-700'
                     : 'bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200'
               }`}
               py={6}
               px={8}>
               <div className="flex gap-3">
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className={`group relative overflow-hidden transition-all duration-300 ${
                           isDark
                              ? 'bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 border border-emerald-500 shadow-lg shadow-emerald-900/30'
                              : 'bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 border border-emerald-400 shadow-lg shadow-emerald-300/30'
                        } text-white font-semibold`}
                        borderRadius="xl"
                        px={8}
                        py={3}
                        _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)' }}
                        _hover={{ transform: 'translateY(-2px)' }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              savefinishRef.current?.focus();
                           }
                        }}>
                        <span className="relative z-10 flex items-center gap-2">
                           <span>💾</span> Save & Continue
                        </span>
                        <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                     </Button>
                  )}

                  <Button
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     ref={savefinishRef}
                     className={`group relative overflow-hidden transition-all duration-300 ${
                        isDark
                           ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 border border-blue-500 shadow-lg shadow-blue-900/30'
                           : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 border border-blue-400 shadow-lg shadow-blue-300/30'
                     } text-white font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode && saveandcontinue === true) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     <span className="relative z-10 flex items-center gap-2">
                        <span>✓</span> Save & Finish
                     </span>
                     <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  </Button>

                  <Button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={onClose}
                     className={`transition-all duration-300 ${
                        isDark
                           ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600 hover:border-red-500'
                           : 'text-gray-700 hover:text-gray-900 hover:bg-red-50 border border-gray-300 hover:border-red-300'
                     } font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           savefinishRef.current?.focus();
                        }
                     }}>
                     <span className="flex items-center gap-2">
                        <span>✕</span> Cancel
                     </span>
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default BankAccountsForm;
